import React from 'react';

import {useInstanceDetailPage} from '../../../../api/hooks/useInstanceDetail.hook';
import {Instance} from '../../../../api/models/instance';
import {Variant} from '../../../../api/models/variant';
import {TypographyVariantsEnum} from '../../../../utils/_enums/typeography-variants.enum';
import {isDateInFuture, isDateInPast} from '../../../../utils/_helper/time-helper';
import {Button} from '../../button/button';
import {Typography} from '../../typography/typography';
import PriceBox from '../_shared/price-box/price-box';
import TransactionFeeBox from '../_shared/transaction-fee-box/transaction-fee-box';
import styles from './fixed-price-sale.module.scss';

export interface FixedPriceSaleProps {
    isInitial?: boolean;
    instance: Instance;
    variant?: Variant;
    isGeoblocked?: boolean;
    onBuy: () => void;
    pending?: boolean;
}

const FixedPriceSale = (props: FixedPriceSaleProps) => {
    const data = useInstanceDetailPage();

    if (data) {
        return (
            <div className={styles['fixed-price-sale']}>
                <div className={styles['fixed-price-left-wrapper']}>
                    <Typography
                        variant={TypographyVariantsEnum.TABLE_TITLE}
                        className={styles['sales-type']}
                        element={'span'}
                    >
                        {props.isInitial
                            ? data?.initialDrop?.content ?? ''
                            : data?.resale?.content ?? ''}
                    </Typography>
                    <div className={styles['price-wrapper']}>
                        <PriceBox
                            ethPrice={props.instance.priceEth}
                            fiatPrice={props.instance.priceFiat}
                            withTaxRate={props.isInitial}
                            currencies={props.isInitial ? 'FIAT_AND_ETH' : 'ETH'}
                        />
                    </div>
                    <TransactionFeeBox gasUsage={147000}/>
                </div>
                <div className={styles['fixed-price-right-wrapper']}>
                    {props.isGeoblocked ? (
                        <Typography
                            variant={TypographyVariantsEnum.CAPTION}
                            element={'span'}
                            className={styles['geo-ip-error']}
                        >
                            {data?.geoIpWarning ?? ''}
                        </Typography>
                    ) : null}
                    <Button
                        onClick={props.onBuy}
                        disabled={isDateInFuture(props?.variant?.salesAttribute?.saleFrom)
                        || (isDateInPast(props?.variant?.salesAttribute?.saleTo)
                            && !props?.instance?.ownerWallet
                            && !props?.instance?.ownerId)
                        || isDateInFuture(props?.instance?.saleStartDate)}
                        pending={props.pending}
                        className={styles['fixed-price-buy']}
                    >
                        {data?.buyButton?.buttonText ?? ''}
                    </Button>
                </div>
            </div>
        );
    } else {
        return <div/>;
    }
};

export default FixedPriceSale;
